import { QueryClient, type VueQueryPluginOptions } from '@tanstack/vue-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false
    }
  }
})

export const vueQueryPluginOptions: VueQueryPluginOptions = {
  queryClient
}

// 第一波先規劃開發環境啟用條件，後續若要接 Devtools 再使用此旗標
export const isVueQueryDevtoolsEnabled = import.meta.env.DEV
